import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { ServiceCards } from '../components/ServiceCards';
import { NewsAlerts } from '../components/NewsAlerts';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="min-h-screen flex flex-col w-full" data-id="element-496">
      <Header data-id="element-497" />
      <main className="flex-grow" data-id="element-498">
        <HeroSection data-id="element-499" />
        <ServiceCards data-id="element-500" />
        <NewsAlerts data-id="element-501" />
      </main>
      <Footer data-id="element-502" />
    </div>;
}